<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <Form
          dispatch="projectAccountingStore/costAllocatorStore/create"
          button_title="create"
          button_icon="mdi-plus"
        ></Form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Form from "./FormCostAllocator";
export default {
  name: "NewCostAllocator",
  components: {
    Form
  }
};
</script>

<style scoped></style>
